define(function(require, exports, module) {
  var PropTypes = require('prop-types');
  var React = require('react');
  var recaptcha = require('common/includes/recaptcha');

  class Recaptcha extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        recaptchaId: '',
      };
    }

    static propTypes = {
      callback: PropTypes.func.isRequired,
      customClass: PropTypes.string,
      elementId: PropTypes.string.isRequired,
      isInvisible: PropTypes.bool.isRequired,
    };

    static defaultProps = {
      customClass: '',
    };

    componentDidMount() {
      var self = this;

      recaptcha.init(self.props.elementId, {
        recaptchaCallback: self.recaptchaCallback,
      }).then(function(recaptchaId) {
        self.setState({ recaptchaId });
      });
    }

    componentDidUpdate(prevProps) {
      if (prevProps.doReset !== this.props.doReset && this.props.doReset) {
        recaptcha.reset(this.state.recaptchaId);
      }
    }

    handleSubmit = () => {
      if (this.props.isInvisible) {
        recaptcha.execute(this.state.recaptchaId);
      }
    };

    recaptchaCallback = () => {
      var response = recaptcha.getResponse(this.state.recaptchaId);

      this.props.callback(response);
    };

    render() {
      return (
        <div
          id={this.props.elementId}
          className={this.props.customClass}
          data-size={this.props.isInvisible ? 'invisible' : 'normal'}
        />
      );
    }
  }

  module.exports = Recaptcha;
});
